export const conversationPurposeMappingRules = {
  EXTRACT_NOTES_FOR_ALL: 1,
  EXTRACT_NOTES_EXCLUDING_TYPES: 2,
  EXTRACT_NOTES_INCLUDING_TYPES: 3
};

export const conversationPurposeOptions = [
  {
    label:
      'Extract notes for all meetings irrespective of Conversation Purposes',
    value: 1
  },
  {
    label:
      'Extract notes for all meetings that have the Conversation Purposes below',
    value: 3
  },
  {
    label:
      'Extract notes for all meetings that do not have the Conversation Purposes below',
    value: 2
  }
];
